'use client';
import React from 'react';
import SpecificationTabData from '../../SpecificationTabData';
import WildsLaunchContainer from '../../../WildsLaunchContainer';

export default function Amenities(props: any) {
  const { t } = props;
  const tabContent = [
    {
      heading: t['amenitiesContent']['title'],
      description: t['amenitiesContent']['desc'],
      listElement: t['amenitiesContent']['list'],
      images: props.tabImages,
    },
  ];
  return (
    <>
      <WildsLaunchContainer>
        <SpecificationTabData
          t={t}
          tabs={tabContent}
          tabThemeImageBackground={props.tabThemeImageBackground}
        />
      </WildsLaunchContainer>
    </>
  );
}
